import { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';

import { notification, Input, Checkbox, message } from 'antd';

import { researchPopupVisible, researchPopupSave, researchPopupClose } from '@lcsc-ui/apis/op';
import useUserStore from '@lcsc-ui/store/user';
import { env } from '@lcsc-ui/utils/baseUrl';

const { TextArea } = Input;

const Rate = forwardRef((props, ref) => {
  const [selectedPointIdx, setSelectedPointIdx] = useState(null);

  useImperativeHandle(ref, () => ({
    getPoint: () => (selectedPointIdx || selectedPointIdx === 0 ? selectedPointIdx + 1 : null),
  }));

  return (
    <ul className="flex justify-between mb-[8px] mt-[15px]">
      {new Array(10).fill('1').map((item, idx) => (
        <li
          className={`${idx === selectedPointIdx ? 'bg-lcBlue text-white' : 'bg-[#ebeef0]'} size-[30px] text-center leading-[30px] cursor-pointer hover:bg-[#D1ECFB]`}
          onClick={() => setSelectedPointIdx(idx)}
          key={idx}
        >
          {idx + 1}
        </li>
      ))}
    </ul>
  );
});

Rate.displayName = 'Rate';

const Desc = forwardRef((props, ref) => {
  const [concatMe, setConcatMe] = useState(false);
  const [content, setContent] = useState(null);

  useImperativeHandle(ref, () => ({
    getConcatMe: () => concatMe,
    getContent: () => content,
  }));

  return (
    <>
      <ul className="flex justify-between text-[14px] text-[#53647C] mb-[15px] mt-[-4px]">
        <li>非常不满意</li>
        <li>非常满意</li>
      </ul>
      <TextArea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        style={{ marginBottom: '8px' }}
        autoSize={{
          minRows: 3,
          maxRows: 3,
        }}
        showCount
        maxLength={200}
        placeholder="您对商城有哪些建议和期望？（选填）"
      ></TextArea>
      <Checkbox checked={concatMe} onChange={(e) => setConcatMe(e.target.checked)}>
        您是否愿意接受我们的回访
      </Checkbox>
    </>
  );
});

Desc.displayName = 'Desc';

const IndexRate = (props) => {
  const { userInfo } = useUserStore();
  const { requestPage = 'home' } = props || {};
  const childRef = useRef();
  const childRef2 = useRef();

  const submitRate = (key, uuid) => {
    const score = childRef.current.getPoint();
    if (!score) {
      message.warning('请选择评分，您的意见对我们非常重要！');
      return;
    }

    // 调用接口保存数据
    researchPopupSave({
      score, // 打分
      isAcceptFollow: childRef2.current.getConcatMe(), // 是否接受回访
      feedbackContent: childRef2.current.getContent() || '', // 建议内容
      researchActivityUuid: uuid, // 调研活动uuid
    })
      .then((res) => {
        if (res?.code === 200) {
          notification.close(key);
          message.success('提交成功！感谢您的宝贵意见。');
        }
      })
      .catch((error) => {
        console.error('提交失败:', error);
        message.error('提交失败，请稍后重试');
      });
  };

  useEffect(() => {
    // 调用接口判断是否显示弹窗
    const checkAndShowPopup = async () => {
      try {
        const res = await researchPopupVisible({ requestPage });
        if (res?.result?.isResearchPopup === true) {
          const uuid = res.result.researchActivityUuid;
          const title = res.result.popupTitle || '您对商城的整体使用体验是否满意？';

          setTimeout(() => {
            const key = `open${Date.now()}`;
            const btn = (
              <button
                className="h-[32px] w-[65px] mt-[2px] bg-[#0093E6] rounded-[6px] hover:opacity-[0.8] text-[white]"
                type="primary"
                size="small"
                onClick={() => submitRate(key, uuid)}
              >
                提 交
              </button>
            );
            const desc = (
              <>
                <Rate ref={childRef} />
                <Desc ref={childRef2} />
              </>
            );
            notification.open({
              message: <span className="font-medium">{title}</span>,
              description: desc,
              btn,
              key,
              onClose: () => {
                notification.close(key);
                researchPopupClose({ researchActivityUuid: uuid }); // 调用接口记录 - 当天不再弹出
              },
              placement: 'bottomRight',
              duration: null,
              style: {
                width: 430,
                height: 303,
              },
            });
          }, 2000);
        }
      } catch (error) {
        console.error('获取弹窗显示状态失败', error);
      }
    };

    if (env === 'local' || userInfo?.customerLogin === 1) {
      checkAndShowPopup();
    }
  }, [userInfo?.customerLogin]);

  return <></>;
};

export default IndexRate;
